import React from 'react';
import SashiDo from 'lib/SashiDo';
import moment from 'moment';
import DashboardView from 'dashboard/DashboardView.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import PreLoader from 'components/PreLoader/PreLoader.react';
import HeatMap from './Requests/HeatMap.react';
import Graph from './Requests/Graph.react';
import WorldMapHOC from './WorldMapHOC.react';

import settingsStyles               from 'dashboard/Settings/Settings.scss';
import styles from './Metrics.scss';

export default class Files extends DashboardView {
  constructor(props) {
    super(props);

    this.section = 'Metrics';
    this.subsection = 'Files';

    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    SashiDo.metricsFilesStorage(this.props.currentApp.id).then((data) => {
      const { metrics } = data;

      const labels = [];
      const datasets = [];

      metrics.forEach((item) => {
        labels.push(item.timestamp);
        datasets.push(item.value || 0);
      });

      const result = metrics.reduce((r, a) => {
        const date = moment(a.timestamp).format('YYYY-MM');
        r[date] = r[date] || 0;
        r[date] = r[date] < a.value ? a.value : r[date];
        return r;
      }, {});

      this.state.filesStorageMetrics = {
        filesStorageOriginalData: metrics,
        last12Months: {
          labels: Object.keys(result),
          datasets: [
            {
              name: 'File Storage',
              values: Object.keys(result).map(key => result[key]),
            }
          ]
        },
        last30Days: {
          labels: labels.slice(1).slice(-30),
          datasets: [
            {
              name: 'File Storage',
              values: datasets.slice(1).slice(-30),
            }
          ]
        },
      }

      this.setState({
        loading: false,
      });
    });


    SashiDo.metricsFilesCount(this.props.currentApp.id).then((data) => {
      const { metrics } = data;

      const labels = [];
      const datasets = [];

      metrics.forEach((item) => {
        labels.push(item.timestamp);
        datasets.push(item.value || 0);
      });

      const result = metrics.reduce((r, a) => {
        const date = moment(a.timestamp).format('YYYY-MM');
        r[date] = r[date] || 0;
        r[date] = r[date] < a.value ? a.value : r[date];
        return r;
      }, {});

      this.state.filesCountMetrics = {
        filesCountOriginalData: metrics,
        last12Months: {
          labels: Object.keys(result),
          datasets: [
            {
              name: 'Files',
              values: Object.keys(result).map(key => result[key]),
            }
          ]
        },
        last30Days: {
          labels: labels.slice(1).slice(-30),
          datasets: [
            {
              name: 'Files',
              values: datasets.slice(1).slice(-30),
            }
          ]
        }
      }

      this.setState({
        loading: false,
      });
    });

    // Traffic Files Status Codes
    SashiDo.metricsFilesStatusCodes(this.props.currentApp.id).then((data) => {
      const result12Months = data.metrics.reduce((r, a) => {
        const date = moment(a.timestamp).format('YYYY-MM');
        r[date] = r[date] || [0,0,0,0];

        Object.keys(a.value).map((key) => {
          if(key.startsWith(2)) {
            r[date][0] += a.value[key];
          }

          if(key.startsWith(3)) {
            r[date][1] += a.value[key];
          }

          if(key.startsWith(4)) {
            r[date][2] += a.value[key];
          }

          if(key.startsWith(5)) {
            r[date][3] += a.value[key];
          }
        });

        return r;
      }, {});


      const result30days = data.metrics.reduce((r, a) => {
        const date = a.timestamp;
        r[date] = r[date] || [0,0,0,0];

        Object.keys(a.value).map((key) => {
          if(key.startsWith(2)) {
            r[date][0] += a.value[key];
          }

          if(key.startsWith(3)) {
            r[date][1] += a.value[key];
          }

          if(key.startsWith(4)) {
            r[date][2] += a.value[key];
          }

          if(key.startsWith(5)) {
            r[date][3] += a.value[key];
          }
        });

        return r;
      }, {});


      this.state.trafficFilesStatusCodes = {
        last12Months: {
          labels: Object.keys(result12Months),
          datasets: [
            {
              name: '2xx',
              values: Object.values(result12Months).map(u => u[0]),
            },
            {
              name: '3xx',
              values: Object.values(result12Months).map(u => u[1]),
            },
            {
              name: '4xx',
              values: Object.values(result12Months).map(u => u[2]),
            },
            {
              name: '5xx',
              values: Object.values(result12Months).map(u => u[3]),
            }
          ].reverse()
        },
        last30Days: {
          labels: Object.keys(result30days).slice(-30),
          datasets: [
            {
              name: '2xx',
              values: Object.values(result30days).map(u => u[0]).slice(-30),
            },
            {
              name: '3xx',
              values: Object.values(result30days).map(u => u[1]).slice(-30),
            },
            {
              name: '4xx',
              values: Object.values(result30days).map(u => u[2]).slice(-30),
            },
            {
              name: '5xx',
              values: Object.values(result30days).map(u => u[3]).slice(-30),
            }
          ].reverse()
        },
      }

      this.setState({
        loading: false,
      });
    });
  }

  renderContent() {
    const { props } = this;
    const {
      filesStorageMetrics,
      filesCountMetrics,
      trafficFilesStatusCodes
    } = this.state;

    let classes = [settingsStyles.settings_page, settingsStyles.default];

    return (
      <div className={classes.join(' ')}>
        <Toolbar section={this.section} subsection={this.subsection} />
        <PreLoader loading={this.state.loading}>
          <div className={settingsStyles.holder}>
            <div className={[styles.holder, styles.withTopPadding].join(' ')}>
              {
                filesStorageMetrics &&
                  <Graph
                    {...props}
                    data={filesStorageMetrics}
                    title='Total Storage'
                    tooltip="Total amount of the application's files storage in S3. Collecting since Aug 20 2016 and updating once a day."
                    unit=''
                    dataFormat='0.[00] b'
                    toolTipDataFormat='0.[00] b'
                    colors={['#98d85b']} />
              }

              <div className={styles.separator} />

              {
                filesCountMetrics &&
                  <Graph
                    {...props}
                    data={filesCountMetrics}
                    title='Total Files'
                    tooltip='Total count of the application files in S3. Collecting since Jun 15 2018 and updating once a day.'
                    unit=''
                    dataFormat='0.[0] a'
                    colors={['#98d85b']} />
              }

              <div className={styles.separator} />

              {
                trafficFilesStatusCodes &&
                  <Graph
                    {...props}
                    data={trafficFilesStatusCodes}
                    title='Responses - Status Codes'
                    tooltip='Collecting since Jul 01 2018 and updating every 8 hours.'
                    unit=''
                    stacked={true}
                    dataFormat='0.[0] a'
                    colors={['#98d85b', '#0092ff', '#ffa00a', '#ff5858'].reverse()} />
              }

              {/* <div className={styles.separator} />

              {
                <WorldMapHOC {...props} />
              } */}
            </div>
          </div>
        </PreLoader>
      </div>
    );
  }
}
